import { useContext } from "react";
import { ButtonDS, GlobalIcon } from "get-life-storybook-ts";
import { I18nContext } from "../../../../../context/i18n.context";
import { GetlifeContext } from "../../../../../context/GetLifeContext.context";

const ContactSidebarCard = () => {
  const {
    state: { translate },
  } = useContext(I18nContext);
  const { handleCallMe } = useContext(GetlifeContext);

  return (
    <div className="dashboard-card flex flex-col gap-[16px]">
      <span className="bg-[var(--theme-quaternary)] rounded-full block w-fit h-fit mx-auto">
        <GlobalIcon iconName="QuestionMark" size="S" color="var(--dark-gray)" />
      </span>
      <span className="BodyL font-bold text-[var(--dark-gray)]">
        {translate("newDashboard.questions")}
      </span>
      <p className="BodyM text-[var(--dark-gray)]">
        {translate("newDashboard.questionsDescription")}
      </p>
      <div className="flex flex-row gap-[12px]">
        <GlobalIcon
          iconName="CalendarTimeIcon"
          size="XS"
          color="var(--theme-primary)"
        />
        <span
          className="flex-1 BodyM text-[#686868]"
          dangerouslySetInnerHTML={{
            __html: translate("newDashboard.schedule"),
          }}
        />
      </div>
      <div className="flex flex-row gap-[12px]">
        <GlobalIcon
          iconName="PhoneIcon"
          size="XS"
          color="var(--theme-primary)"
          colorFill="transparent"
        />
        <span className="flex-1 BodyM text-[#686868] font-medium">
          {translate("newDashboard.contactPhone")}
        </span>
      </div>
      <div className="flex flex-row gap-[12px]">
        <GlobalIcon iconName="MailIcon" size="XS" color="var(--theme-primary)" />
        <span className="flex-1 BodyM text-[#686868] font-medium">
          {translate("newDashboard.contactEmail")}
        </span>
      </div>
      <ButtonDS
        label={translate("newDashboard.faqButton")}
        rightIcon="QuestionMark2Icon"
        href="https://life5.es/preguntas-frecuentes/"
        target="_blank"
        size="32"
        className="!no-underline"
      />
      <ButtonDS
        label={translate("newDashboard.bookCall")}
        leftIcon="CalendarEventIcon"
        size="32"
        className="!no-underline"
        buttonType="secondary"
        onClick={handleCallMe}
      />
    </div>
  );
};

export default ContactSidebarCard;
